import z from "zod";

export const aiTextImproveSchema = z.object({
	input: z.string(),
});
